import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'sanitizeContentfulHTML',
  standalone: true,
})

/**
 * IMPORTANT: This pipe is "contentful specific", so make sure it's appropiate for your case.
 * This pipe use the angular platform-browser DomSanitizer class (sanitize method: https://angular.io/api/platform-browser/DomSanitizer#sanitize),
 * The sanitizer allowed elements are defined in:  https://github.com/angular/angular/blob/main/packages/core/src/sanitization/html_sanitizer.ts#L69
 * This checks if the given value is already a 'SafeValue' (wrapper class around the string), if that's the case then it returns the unwrapped value
 * otherwise the method sanitize the string, removing any potentially unsafe content.
 */
export class SanitizeContentfulHTMLPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(innerHTMLContent: string): SafeHtml {
    return this.sanitizer.sanitize(SecurityContext.HTML, innerHTMLContent) || '';
  }
}
